import styled, { isCanvasTheme } from 'foundations-theming/utils';
import { ONBOARDING_COLOR } from './colors';
export const TourButtonLabel = styled.div.withConfig({
  displayName: "styles__TourButtonLabel"
})(["font-family:", ";font-size:", ";font-weight:", ";color:", ";"], ({
  theme
}) => theme.typography['detail-100'].fontFamily, ({
  theme
}) => theme.typography['detail-100'].fontSize, ({
  theme
}) => theme.typography['detail-100'].fontWeight, ({
  theme
}) => isCanvasTheme(theme) ? 'inherit' : theme.color[ONBOARDING_COLOR]);
export const OnFillLinkOverride = styled.div.withConfig({
  displayName: "styles__OnFillLinkOverride"
})(["--trellis-color-text-interactive-default:var( --trellis-color-text-interactive-on-fill-default );--trellis-color-text-interactive-default-hover:var( --trellis-color-text-interactive-on-fill-hover );--trellis-color-text-interactive-default-pressed:var( --trellis-color-text-interactive-on-fill-pressed );a:not([data-button-use]){text-decoration:underline;}a[data-button-use]:hover{text-decoration:none;}"]);